module.exports = __webpack_public_path__ + "static/media/fa-brands-400.fe9d62e0.woff";